import {default as Component} from './ResultTable'
import { delDomainResource } from '../../redux/endpointActions'
import { toggleDomainEdit } from '../../redux/actions';
import {connect} from 'react-redux'

const servicePath = process.env.REACT_APP_SERVICE_ENDPOINT + 'user/domain/resource'

const ResultTable = connect(
	(state) => ({
		domains: state.siteData.domains,
		resources: state.siteData.resources,
    editableDomain: state.siteData.editableDomain,
		deleteDomainResource: (state.login.isLoggedIn ?
			delDomainResource(servicePath, state.login.userToken.AuthenticationResult.AccessToken,
				state.login.userToken.AuthenticationResult.IdToken) : (resourceUrl) => (() => {
			}))
	}),
	(dispatch) => ({
    toggleDomainEdit: (domain) => {
      dispatch(toggleDomainEdit(domain))
    },
		dispatch: dispatch
	}),
	(stateProps, dispatcherProps) => ({
		domains: stateProps.domains,
		resources: stateProps.resources,
    editableDomain: stateProps.editableDomain,
    toggleDomainEdit: dispatcherProps.toggleDomainEdit,
		deleteDomainResource: (resourceUrl) => {
			stateProps.deleteDomainResource(resourceUrl)(dispatcherProps.dispatch)
		}
	})
)(Component)

ResultTable.defaultProps = {
	domains: null,
	resources: null,
  editableDomain: null,
  toggleDomainEdit: null,
  deleteDomainResource: null,
	
}

export default ResultTable


// WEBPACK FOOTER //
// ./src/components/ResultTable/index.js